/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from 'react';
import { Col, Row } from 'react-bootstrap';
import TabsUnstyled from '@mui/base/TabsUnstyled';
import TabsListUnstyled from '@mui/base/TabsListUnstyled';
import TabUnstyled from '@mui/base/TabUnstyled';
import PersonAddOutlinedIcon from 'components/icons/PersonAddOutlineIcon';
import PersonalInformationOutlinedIcon from 'components/icons/PersonalInformationOutlinedIcon';
import BillingOutlineIcon from 'components/icons/BillingOutlineIcon';
import LockOutlinedIcon from 'components/icons/LockOutlinedIcon';
import BellOutlinedIcon from 'components/icons/BellOutlinedIcon';
import SettingsPersonalInformation from './components/SettingsPersonalInformation';
import SettingsSecurity from './components/SettingsSecurity';
import SettingsCounselor from './components/SettingsCounselor';
import SettingsNotification from './components/SettingsNotification';
import SchoolOutlinedIcon from '@mui/icons-material/SchoolOutlined';
import SettingsMajor from './components/SettingsMajor';
import SettingBilling from './components/SettingBilling';
import { USER_ROLE } from 'constants/common';
import { useHistory, useLocation } from 'react-router-dom';
import PaymentServices from 'services/payment';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import Cookies from 'js-cookie';
import SettingsParent from './components/SettingsParent';
import SettingsStudents from './components/SettingsStudents';
import { getUserId } from 'utils/sessionStorage';
//import { AnyAction } from '@reduxjs/toolkit';
//import { AssistWalker } from '@mui/icons-material';

const searchParamsToObject = (str: string) => {
  return str
    .slice(1)
    .split('&')
    .map((p) => p.split('='))
    .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
};

const PersonalSetting = () => {
  const history = useHistory();
  let location = useLocation(); 
  const [activeTab, setActiveTab] = React.useState<any>(0); 
  const [portalUrl, setPortalUrl] = React.useState('');
  const information = useAppSelector((store) => store.basicInformation.myBasicInformation);
  const userRole  = information?.user_role ?? sessionStorage.getItem('userRole');

  const getPortalUrl = () => {
    const domainUrl = `${window.location.origin}`;
    const studentId = parseInt(getUserId() ?? '0');      
    if (userRole === USER_ROLE.student) {
        PaymentServices.getBillPortalUrl(domainUrl, studentId).then((res: any) => {
          setPortalUrl(res);
          console.log('portalUrl: ',res);
        });
    }
  }

  useEffect(() => {
    getPortalUrl();
  }, []);


  //#region Create Fixed Column - Setting Menu
  React.useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.innerHTML = `
      function FixedSettingMenuColumn() {
        var w = ((window.innerWidth - 50)* 16.66666667 /100) ; // .col-md-2     
        let col = document.querySelector("#col-setting-menu");
        if (col) {
        col.style.width = null; // remove style width
        if (window.innerWidth > 1024){
          col.style.width = w +'px';
        }}
      }

      // call on document ready
      FixedSettingMenuColumn();

      // call on resize event
      window.addEventListener('resize', function(){
          FixedSettingMenuColumn();
      });

    `;
    document.body?.appendChild(script);
  }, []);
  //#endregion
  
  useEffect(() => {
    const params: any = searchParamsToObject(location.search);
    if (params?.['active-tab'] !== activeTab.toString()) {
      const tab = params?.['active-tab'] ? parseInt(params?.['active-tab']) : 0;
      setActiveTab(tab);
    }
  }, [location.search]);
  return (
    <TabsUnstyled defaultValue={0}>
      <div className="gm-setting">
        <Row className="m-0">
          <Col md={2} id="col-setting-menu" className="col-setting-menu col-sm-12 m-0 p-0">
            <TabsListUnstyled
              id="tablist-menu"
              className="d-flex flex-md-column flex-row align-items-between rounded border-light mobile-tabs-container"
            >
              <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 0 ? 'activated' : ''}`}
                style={{ minWidth: '190px' }}
                onClick={() => {
                  setActiveTab(0);
                  history.replace({ search: `active-tab=0` });
                }}
              >
                <PersonalInformationOutlinedIcon
                  className="icon-style"
                  width={'18px'}
                  height={'18px'}
                />
                <span className="title">Personal Information</span>
              </TabUnstyled>

              <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 2 ? 'activated' : ''}`}
                style={{ minWidth: '120px' }}
                onClick={() => {
                  setActiveTab(2);
                  history.replace({ search: `active-tab=2` });
                }}
              >
                <LockOutlinedIcon className="icon-style" />
                <span className="title">Password</span>
              </TabUnstyled>

              {userRole === USER_ROLE.student && (
                <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 3 ? 'activated' : ''}`}
                style={{ minWidth: '110px' }}
                onClick={() => {
                  setActiveTab(3);
                  history.replace({ search: `active-tab=3` });
                }}
                id="tab-student-3"
              >
                <PersonAddOutlinedIcon className="icon-style" />
                <span className="title">Counselors</span>
              </TabUnstyled>
              )}
              {userRole === USER_ROLE.counselor && (
                <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 3 ? 'activated' : ''}`}
                style={{ minWidth: '110px' }}
                onClick={() => {
                  setActiveTab(3);
                  history.replace({ search: `active-tab=3` });
                }}
                id="tab-student-3"
              >
                <PersonAddOutlinedIcon className="icon-style" />
                <span className="title">Students</span>
              </TabUnstyled>
              )}
              {userRole === USER_ROLE.student && (
                <TabUnstyled
                  className={`tab-label text-start mobile-tab-item ${activeTab === 6 ? 'activated' : ''}`}
                  style={{ minWidth: '110px' }}
                  onClick={() => {
                    setActiveTab(6);
                    history.replace({ search: `active-tab=6` });
                  }}
                  id="tab-student-parent"
                >
                  <PersonAddOutlinedIcon className="icon-style" />
                  <span className="title">Parents</span>
                </TabUnstyled>
              )}       
              {userRole === USER_ROLE.parent && (
                <TabUnstyled
                  className={`tab-label text-start mobile-tab-item ${activeTab === 6 ? 'activated' : ''}`}
                  style={{ minWidth: '110px' }}
                  onClick={() => {
                    setActiveTab(6);
                    history.replace({ search: `active-tab=6` });
                  }}
                  id="tab-parent-student"
                >
                  <PersonAddOutlinedIcon className="icon-style" />
                  <span className="title">Students</span>
                </TabUnstyled>
              )}
              {userRole === USER_ROLE.student && (
                <TabUnstyled
                  className={`tab-label text-start mobile-tab-item ${activeTab === 1 ? 'activated' : ''}`}
                  style={{ minWidth: '190px' }}
                  onClick={() => {
                    setActiveTab(1);
                    history.replace({ search: `active-tab=1` });
                  }}
                  id="tab-student-1"
                >
                  <SchoolOutlinedIcon className="icon-style" width={'18px'} height={'18px'} />
                  <span className="title">Majors of Interests</span>
                </TabUnstyled>
              )}
              {/* <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 4 ? 'activated' : ''}`}
                style={{ minWidth: '130px' }}
                onClick={() => {
                  setActiveTab(4);
                  history.replace({ search: `active-tab=4` });
                }}
              >
                <BellOutlinedIcon className="icon-style" />
                <span className="title">Notifications</span>
              </TabUnstyled> */}

              {userRole === USER_ROLE.student && (
              <TabUnstyled
                className={`tab-label text-start mobile-tab-item ${activeTab === 5 ? 'activated' : ''}`}
                style={{ minWidth: '130px' }}
                onClick={() => {                 
                  setActiveTab(5);
                  history.replace({ search: `active-tab=5` });
                }}
              >
                <BillingOutlineIcon className="icon-style" />
                <span className="title">Billing</span>
              </TabUnstyled>
              )}
            </TabsListUnstyled>
          </Col>
          <Col md={9} className="col-setting-content col-sm-12 m-0 p-0">
            {activeTab === 0 && <SettingsPersonalInformation />}
            {activeTab === 1 && <SettingsMajor />}
            {activeTab === 2 && <SettingsSecurity />}
            {activeTab === 3 && <SettingsCounselor />}
            {activeTab === 4 && <SettingsNotification />}
            {portalUrl && activeTab === 5 && <SettingBilling />}
            {activeTab === 6 && userRole === USER_ROLE.student && <SettingsParent />}
            {activeTab === 6 && userRole === USER_ROLE.parent && <SettingsStudents />}            
          </Col>
        </Row>
      </div>
    </TabsUnstyled>
  );
};

export default PersonalSetting;
